import { render, staticRenderFns } from "./PanelThemesHeader.vue?vue&type=template&id=28b30a16&scoped=true"
import script from "./PanelThemesHeader.vue?vue&type=script&lang=js"
export * from "./PanelThemesHeader.vue?vue&type=script&lang=js"
import style0 from "./PanelThemesHeader.vue?vue&type=style&index=0&id=28b30a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b30a16",
  null
  
)

export default component.exports